import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { playerStats } from '../data/playerStats';
import { useTranslation } from 'react-i18next';

export default function PlayerLineChart() {
  const { t } = useTranslation();
  const [selectedPlayer, setSelectedPlayer] = useState("Carlos Vela");
  const [yearRange, setYearRange] = useState([2020, 2024]);

  const allYears = [2020, 2021, 2022, 2023, 2024, 2025];

  // Filter data by selected year range
  const data = playerStats[selectedPlayer].filter(
    d => d.year >= yearRange[0] && d.year <= yearRange[1]
  );

  return (
    <div style={{ marginTop: '2rem' }}>
      <h2>{t('chart1')}</h2>

      <div style={{ marginBottom: '1rem' }}>
        <label style={{ marginRight: '0.5rem' }}>{t('selectPlayer') || 'Select Player'}:</label>
        <select
          onChange={(e) => setSelectedPlayer(e.target.value)}
          value={selectedPlayer}
          style={{ marginRight: '1rem' }}
        >
          {Object.keys(playerStats).map((player) => (
            <option key={player} value={player}>{player}</option>
          ))}
        </select>

        <label style={{ marginRight: '0.5rem' }}>{t('from') || 'From'}:</label>
        <select
          value={yearRange[0]}
          onChange={(e) => setYearRange([Number(e.target.value), yearRange[1]])}
          style={{ marginRight: '1rem' }}
        >
          {allYears.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>

        <label style={{ marginRight: '0.5rem' }}>{t('to') || 'To'}:</label>
        <select
          value={yearRange[1]}
          onChange={(e) => setYearRange([yearRange[0], Number(e.target.value)])}
        >
          {allYears.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="goals" stroke="#8884d8" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
